<script>

    import layer from "@/mixins/mapboxLayer"

    export default{

        mixins:[layer],
        
        name:"courseplanejamento",

        props:["trecho","runner"], 

        data(){
            return {
                nameLayerFromData:"planejamento"
            }
        },

        created () {
            this.nameLayerFromData = "planejamentocourse"+_.get(this,'trecho.properties.numero',_.uniqueId('planejamento'));
        },


        computed:{
            geoJSON:function(){

                 return this.trecho;
            },
        },

        watch:{
            geoJSON:function(){
                this.animateLine(1, true)
            }
        },


        beforeDestroy:function(){
            debugger;
        },


        methods:{

        },
        
        style: function () {

            var color = this.runner.color
            return {
                "id": "percurso",
                "type": "line",
                // "source": "percurso",
                "layout": {
                    "line-join": "round",
                    "line-cap": "round"
                },
                "paint": {
                    "line-color": {
                        "base": 1,
                        "stops": [
                            [9, '#333333'],
                            [11, color]
                        ]
                    },
                    "line-width": {
                        "base": 1,
                        "stops": [
                            [9, 6],
                            [11, 12]
                        ]
                    },
                    "line-opacity": {
                        "base": 1,
                        "stops": [
                            [9, 1],
                            [11, 1]
                        ]
                    },
                }
            }
        }

    }


</script>